export const UPSELL_SERVICE_CODE_MAP = {
  // Only surface WFC Advanced variants for WFC upsells.
  worry_free_service_advanced: [
    'worry_free_service_advanced',
    'worry_free_service_advanced_addon'
  ]
};

export const ALLOWED_ORDER_TASKS = [
  'llc_formation',
  'corp_formation',
  'ein_creation',
  'business_license_report',
  'zb_banking_preferred',
  'llc_annual_report',
  'corp_annual_report',
  'llc_amendment',
  'corp_amendment',
  'change_of_registered_agent',
  'ny_publication',
  'registered_agent_service',
  'llc_initial_report',
  'website_tools_bundle',
  'business_license_filing',
  'domain_name_reg'
];

// this order task type to entitlement
// mapping comes from https://github.com/zenbusiness/entitlements-api/blob/main/server/api/businesses/constants.js

export const EIN_UPSELL = {
  title: 'dashboard.orderTracker.upsell.ein',
  url: '/dashboard/{BUUID}/products/ein-creation',
  entitlement: 'ein_creation'
};

export const BLR_UPSELL = {
  title: 'dashboard.orderTracker.upsell.blr',
  url: '/dashboard/{BUUID}/compliance/business-licenses',
  entitlement: 'business_license_report'
};

export const MONEY_UPSELL = {
  title: 'dashboard.orderTracker.upsell.money',
  url: '/dashboard/{BUUID}/products/money-pro',
  entitlement: 'accounting'
};

export const TAX_ADVISE_UPSELL = {
  title: 'dashboard.orderTracker.upsell.taxAdvise',
  url: '/dashboard/{BUUID}/products/tax-advice',
  entitlement: 'tax_annual_filing'
};

export const TRADEMARKS_SEARCH_UPSELL = {
  title: 'dashboard.orderTracker.upsell.trademarksSearch',
  url: '/dashboard/{BUUID}/products/trademarks-search',
  entitlement: 'trademarks_search'
};

export const WFC_UPSELL = {
  title: 'dashboard.orderTracker.upsell.wfc',
  url: '/dashboard/{BUUID}/products/wfc-services?package=basic',
  entitlement: 'worry_free_service'
};

export const WFC_ADVANCED_UPSELL = {
  title: 'dashboard.orderTracker.upsell.wfcAdvanced',
  url: '/dashboard/{BUUID}/products/wfc-advanced',
  entitlement: 'worry_free_service_advanced'
};

export const NY_PUBLICATION_UPSELL = {
  title: 'dashboard.orderTracker.upsell.nyPublication',
  entitlement: 'ny_publication',
  allowedJurisdictions: ['NY'],
  useSlideSheet: true
};

export const RA_UPSELL = {
  title: 'dashboard.orderTracker.upsell.registeredAgent',
  url: '/dashboard/{BUUID}/products/registered-agent',
  entitlement: 'registered_agent_service'
};

export const ANNUAL_REPORT_UPSELL = {
  title: 'dashboard.orderTracker.upsell.annualReport',
  url: '/dashboard/{BUUID}/products/annual-report',
  entitlement: 'llc_annual_report'
};

export const INITIAL_REPORT_UPSELL = {
  title: 'dashboard.orderTracker.upsell.initialReport',
  url: '/dashboard/{BUUID}/products/initial-report',
  entitlement: 'llc_initial_report'
};

export const WEBSITE_TOOLS_UPSELL = {
  title: 'dashboard.orderTracker.upsell.websiteTools',
  url: '/dashboard/{BUUID}/products/website-tools-bundle',
  entitlement: 'website_tools_bundle'
};

export const BUSINESS_LICENSE_FILING_UPSELL = {
  title: 'dashboard.orderTracker.upsell.businessLicenseFiling',
  url: '/dashboard/{BUUID}/products/business-license-filing',
  entitlement: 'business_license_filing'
};

export const CHANGE_OF_REGISTERED_AGENT_UPSELL = {
  title: 'dashboard.orderTracker.upsell.changeOfRegisteredAgent',
  url: '/dashboard/{BUUID}/products/change-of-registered-agent',
  entitlement: 'change_of_registered_agent'
};

export const CORPORATE_DOCS_UPSELL = {
  title: 'dashboard.orderTracker.upsell.corporateDocs',
  url: '/dashboard/{BUUID}/products/corporate-docs',
  entitlement: 'corporate_docs'
};

export const ORDER_TASKS_UPSELLS = {
  llc_formation: [
    EIN_UPSELL,
    NY_PUBLICATION_UPSELL,
    BLR_UPSELL,
    WFC_UPSELL,
    TRADEMARKS_SEARCH_UPSELL
  ],
  corp_formation: [
    EIN_UPSELL,
    NY_PUBLICATION_UPSELL,
    BLR_UPSELL,
    WFC_UPSELL,
    TRADEMARKS_SEARCH_UPSELL
  ],
  ein_creation: [
    NY_PUBLICATION_UPSELL,
    BLR_UPSELL,
    WFC_UPSELL,
    TRADEMARKS_SEARCH_UPSELL
  ],
  business_license_report: [
    WFC_UPSELL,
    TRADEMARKS_SEARCH_UPSELL
  ],
  beneficial_ownership_filing: [
    BLR_UPSELL
  ],
  zb_banking_preferred: [
    MONEY_UPSELL,
    TAX_ADVISE_UPSELL
  ],
  ny_publication: [
    BLR_UPSELL
  ],
  llc_amendment: [
    WFC_UPSELL,
    RA_UPSELL
  ],
  annual_reports: [
    ANNUAL_REPORT_UPSELL,
    RA_UPSELL,
    WFC_UPSELL,
    INITIAL_REPORT_UPSELL
  ],
  basic_email: [
    WEBSITE_TOOLS_UPSELL
  ],
  business_license_filing: [
    BUSINESS_LICENSE_FILING_UPSELL
  ],
  change_of_registered_agent: [
    CHANGE_OF_REGISTERED_AGENT_UPSELL
  ],
  domain_name_reg: [
    WEBSITE_TOOLS_UPSELL
  ]
};

export const CHIP_COLORS = {
  action_req: 'warning',
  incomplete: 'warning',
  pending: 'primary',
  processing: 'info'
};
